module.exports = __webpack_public_path__ + "img/29_44.01107a71.png";